import { BellOutlined, CloseCircleOutlined, EditFilled, FolderOutlined } from "@ant-design/icons"
import { Button, Input, Space } from "antd"
import { useEffect, useState } from "react";
import { CustomTag } from "./interface";
import { useCustomEventListener } from "react-custom-events";
import { addNewTag } from "./tagUtils";

interface AddTagProps {
    handleCancel: () => void;
    handleSave: (newTag: CustomTag) => void;
  }

interface CustomEventNewTag {
    location?: number[];
}

export default function AddTag({ handleSave, handleCancel }: AddTagProps) {
    const [newTag, setNewTag] = useState<CustomTag>({
        id: ((Math.random() * 10000) + 1).toString(),
        name: "",
        description: "",
        location: null,
        dataIds: [],
    });

    const set = (prop: string, value: string) => {
        setNewTag(prevTag => ({ ...prevTag!, [prop]: value }));
    };

    let isSaveDisabled = !newTag || !newTag.id || !newTag.name || !newTag.location || !newTag.dataIds.length;

    useCustomEventListener("newTag", (e: CustomEventNewTag) => {
        let location = e.location ? e.location : [0, 0];
        let dataIds: string[] = [];
        window.potreeViewer.scene.pointclouds.forEach((pointcloud: any) => {
            if (pointcloud.visible) {
                dataIds.push(pointcloud.data_id);
            }
        });

        const maxId = Math.random() * 10000;
        const newTagData: CustomTag = {
            id: newTag?.id || (maxId + 1).toString(),
            description: newTag?.description || "",
            name: newTag?.name || "",
            location: location,
            dataIds: dataIds,
        }
        setNewTag(newTagData);
    });

    const save = () => {
        if (!newTag || !newTag.location) return;
        addNewTag(newTag.name, newTag.description, newTag.location, newTag.dataIds);
        handleSave(newTag);
    }

    return (
        <div className="create_tag">
            <h2 className="title_tag">Add Tag</h2>
            <div className="sub_title">
                <p>Point Location: </p>
            </div>
            <div className="sub_title_message">
                <BellOutlined /> Select Point On 3D Viewer
            </div>
            <div className="map_point">
                <div className="map_data">
                    <p>X : </p>
                    <span className="map_section">
                        {newTag?.location?.map((e: number) => e.toFixed(2)).join(",")}
                    </span>
                </div>
                <div className="map_data">
                    <p>Y : </p>
                    <span className="map_section">
                        {newTag?.location?.map((e: number) => e.toFixed(2)).join(",")}
                    </span>
                </div>
                <div className="map_data">
                    <p>Z : </p>
                    <span className="map_section">
                        {newTag?.location?.map((e: number) => e.toFixed(2)).join(",")}
                    </span>
                </div>
            </div>
            <div className="form_section">
                <div className="input_with_icon">
                    <label htmlFor="name">Name</label>
                    <Input
                        id="name"
                        value={newTag?.name || ""} 
                        onInput={(e: React.ChangeEvent<HTMLInputElement>) => { set("name", e.target.value) }}
                        autoComplete="nope"
                    />
                </div>
                <div className="input_with_icon">
                    <label htmlFor="description">Description</label>
                    <div className="textarea_with_icon">
                        <Input.TextArea
                            id="description"
                            value={newTag?.description || ""}
                            className="textarea_section"
                            onInput={(e: React.ChangeEvent<HTMLTextAreaElement>) => { set("description", e.target.value) }}
                        />
                    </div>
                </div>
                <Space className="footer_btn">
                    <Button
                        className="save_btn"
                        icon={<FolderOutlined />}
                        onClick={save}
                        disabled={isSaveDisabled}
                    >
                        Save
                    </Button>
                    <Button
                        className="cancel_btn"
                        icon={<CloseCircleOutlined />}
                        onClick={handleCancel}
                    >
                        Cancel
                    </Button>
                </Space>
            </div>
        </div>
    )
}